import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { conciergeApi, errMsg } from "@/components/concierge/api";
import { PersonForm } from "@/components/concierge/PersonForm";
import { PersonRow } from "@/components/concierge/PersonRow";

export const CompanyClients = ({ company, onBack, onOpen }) => {
  const [clients, setClients] = useState([]);

  const load = useCallback(async () => {
    const res = await conciergeApi.get(`/companies/${company.id}/clients`);
    setClients(res.data);
  }, [company.id]);

  useEffect(() => { load(); }, [load]);

  const add = async (form) => {
    try {
      await conciergeApi.post(`/companies/${company.id}/clients`, form);
      toast.success("Client ajouté");
      load();
      return true;
    } catch (error) {
      toast.error(errMsg(error));
      return false;
    }
  };

  const remove = async (p) => {
    if (!window.confirm(`Retirer ${p.first_name} ${p.last_name} de la liste ? (ses bons restent dans l'historique)`)) return;
    await conciergeApi.delete(`/clients/${p.id}`);
    load();
  };

  return (
    <div className="space-y-4" data-testid="concierge-company-clients">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={onBack} data-testid="company-back-btn"><ArrowLeft className="w-4 h-4 mr-1" />Entreprises</Button>
        <h3 className="text-lg font-bold">{company.name}</h3>
      </div>
      <PersonForm onSubmit={add} prefix="client" />
      <div className="space-y-2">
        {clients.map((p) => (
          <PersonRow key={p.id} person={p} onDelete={() => remove(p)} onOpen={() => onOpen({ ...p, type: "client", company_name: company.name })} />
        ))}
        {clients.length === 0 && <p className="text-center text-slate-400 py-6">Aucun client dans cette entreprise</p>}
      </div>
    </div>
  );
};
